import { useCallback, useRef } from 'react';

import { isUndefined } from 'utils/tsHelpers';

type DataType = string;
type Mapping = string;
type MappingId = number;

export const useMappingIdCache = () => {
  const idCounter = useRef<number>(0);
  const cache = useRef<Record<DataType, Record<Mapping, MappingId>>>({});

  const getIdForMapping = useCallback(
    (dataType: DataType, mapping: Mapping) => {
      if (isUndefined(cache.current[dataType])) cache.current[dataType] = {};
      if (isUndefined(cache.current[dataType][mapping])) {
        cache.current[dataType][mapping] = idCounter.current;
        idCounter.current += 1;
      }
      return cache.current[dataType][mapping];
    },
    [cache],
  );

  return { getIdForMapping };
};
